<template>
  <div id="page-applicant-mailer">
    <vx-card>
      <div slot="no-body" class="p-6">
        <h1 class="mb-8">
          Mailer - {{ applicant.firstName }} {{ applicant.lastName }}
        </h1>
        <form>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h4>Historie</h4>
            </div>
            <div class="vx-col w-full md:w-1/3">
              <DataInput
                v-model="createHistoryEntry"
                type="bool"
                class="w-full mt-4"
                label="In Historie abspeichern"
                name="history"
              />
            </div>
            <div class="vx-col w-full md:w-2/3">
              <DataInput
                v-model="history.typeID"
                type="model"
                class="w-full mt-4"
                label="Art"
                name="typeID"
                model-label="nameHistory"
                select-label="nameHistory"
                gql-query="actionTypes"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h4>Wiedervorlage</h4>
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="createResubmission"
                type="bool"
                class="w-full mt-4"
                label="Aktivieren"
                name="resubmission"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.consultantID"
                type="model"
                class="w-full mt-4"
                label="Berater"
                name="consultantID"
                model-label="
                  firstName
                  lastName"
                :select-label="el => el.firstName + ' ' + el.lastName"
                gql-query="consultantsPage"
                gql-single-query="consultant"
                gql-filter-type="objectFilter"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.dueAt"
                type="date"
                class="w-full mt-4"
                label="am"
                name="date"
              />
            </div>
            <div class="vx-col w-full md:w-1/5">
              <DataInput
                v-model="resubmission.typeID"
                type="model"
                class="w-full mt-4"
                label="Art"
                name="typeID"
                model-label="nameResubmission"
                select-label="nameResubmission"
                gql-query="actionTypes"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <h3>E-Mail</h3>
            </div>
            <TextTemplateChooser
              label="Vorlage"
              type="APPLICANT"
              class="w-full md:mt-4 p-3"
              :data="templateData"
              @textChoosen="presetSelected"
            />
            <div class="vx-col w-full">
              <DataInput
                v-model="mailForm.title"
                class="w-full mt-4"
                label="Betreff"
                name="title"
              />
            </div>
            <div class="vx-col w-full">
              <DataInput
                v-model="mailForm.text"
                type="html"
                class="w-full mt-4"
                label="Brieftext"
                name="text"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <input
                ref="attachments"
                type="file"
                class="w-full mt-4"
                label="Anhänge"
                multiple
                name="attachments"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <DataInput
                v-model="mailForm.sendCopy"
                type="bool"
                class="w-full mt-4"
                label="Kopie an mich senden"
                name="sendCopy"
              />
            </div>
          </div>
          <vs-button @click="submit">Senden</vs-button>
        </form>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import TextTemplateChooser from "./TextTemplateChooser";
import gql from "graphql-tag";

export default {
  components: {
    DataInput,
    TextTemplateChooser
  },
  data: () => ({
    mailForm: {
      title: null,
      text: null,
      sendCopy: false,
      attachments: []
    },
    resubmission: {},
    history: {},
    createResubmission: false,
    createHistoryEntry: true
  }),
  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            salutation
            firstName
            lastName
            createdAt
            contactData {
              telephone
              telephoneMobile
              email
              address {
                street
                zip
                city
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    },
    me: gql`
      query {
        me {
          id
          email
          consultant {
            id
            firstName
            lastName
            position
            telephone
            telephoneOffice
            fax
            zip
            city
            street
          }
        }
      }
    `
  },
  computed: {
    templateData() {
      return {
        applicant: this.applicant,
        consultant: this.me ? this.me.consultant : {},
        user: this.me ? this.me : {}
      };
    }
  },
  methods: {
    presetSelected(preset) {
      this.mailForm.title = preset.subject;
      this.mailForm.text = preset.content;
    },
    async submit() {
      const toBase64 = file =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(",")[1]);
          reader.onerror = error => reject(error);
        });

      let filesSize = 0;
      this.mailForm.attachments = [];
      for (let file of this.$refs["attachments"].files) {
        filesSize += file.size;
        this.mailForm.attachments.push({
          filename: file.name,
          contentType: file.type,
          base64Content: await toBase64(file)
        });
      }

      if (filesSize > 5000000) {
        alert("Maximal 5MB Anhänge.");
        return;
      }

      if (this.createResubmission) {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: NewAction!) {
                createAction(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                ...this.resubmission,
                description: this.mailForm.text,
                done: false,
                refID: this.$route.params.id,
                refType: "APPLICANT"
              }
            }
          })
          .catch(error => {
            this.loginErrors = error.graphQLErrors.map(m => m.message);
          });
      }

      if (this.createHistoryEntry) {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($input: NewAction!) {
                createAction(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                ...this.history,
                description: this.mailForm.text,
                done: true,
                refID: this.$route.params.id,
                refType: "APPLICANT",
                consultantID: this.me.consultant.id,
                dueAt: new Date(),
                title: this.mailForm.title
              }
            }
          })
          .catch(error => {
            this.loginErrors = error.graphQLErrors.map(m => m.message);
          });
      }

      this.$apollo.mutate({
        mutation: gql`
          mutation SendMail($applicantID: ID!, $input: ApplicantMailerInput!) {
            sendApplicantMail(applicantID: $applicantID, input: $input)
          }
        `,
        variables: {
          applicantID: this.$route.params.id,
          input: {
            ...this.mailForm,
            sendFrom: this.me.email
          }
        }
      });

      this.$vs.notify({
        title: "Abgeschickt",
        text: "Alles wurde erfolgreich abgeschickt!",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });

      this.$router.push({
        name: "applicant.edit",
        params: { id: this.$route.params.id }
      });
    }
  }
};
</script>
